import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { FormTitle } from "../members/formComponents/FormTitle"
import { FormButton } from "../members/formComponents/FormButton"
import { Redirect } from "react-router-dom"
import {
  Container,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Alert,
  Input,
  Card,
} from "reactstrap"
import { Trans, useLingui } from "@lingui/react"
import uuid from "uuid"
import updateTransanction from "../reverseTransactions/updateTransaction"
import memberToIssuer from "./memberToIssuer"
import { toast } from "react-toastify"
import {
  SuccessMessage,
  ErrorMessage,
  WarningMessage,
} from "../../view/shared/notifications/Notifications"
import { getCurrency } from "../../view/shared/utilities/currency"
import { reverseTransaction } from "../../store/reducers/transactions/actions"
import { setCurrentPage } from "../../store/reducers/navigation"
import StellarLoader from "../layout/StellarLoader"
import { blockchainAPI } from "../../store/api"

const LastLoanRepayment = (props) => {
  const { i18n } = useLingui()

  const {
    transactions,
    disableLoanInterestReversal,
    offlineMeeting,
    member,
  } = props
  const [state, setState] = useState({
    reverse: false,
    loading: false,
    redirect: false,
  })
  const dispatch = useDispatch()
  const { user, ongoingMeeting, vsla, currentMember, group } = useSelector(
    (state) => ({
      user: state.user,
      ongoingMeeting: state.meeting?.ongoing,
      vsla: state.vsla,
      currentMember: state.loadedMember,
      group: state.group,
    }),
  )

  const notify = (msg) => toast(msg)

  const toggleReverse = () => {
    return !state.reverse
  }

  const onChange = (e) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmez que vous souhaitez activer l'annulation des transactions`,
      },
      en: {
        message: `Confirm you want to activate reversal of transactions`,
      },
      sw: {
        message: `Thibitisha unataka kuwezesha kurejeshea mwanachama mchango`,
      },
      es: {
        message: `Confirme que desea activar la reversión de transacciones`,
      },
      lb: {
        message: `Confirm you want to activate reversal of transactions`,
      },
      pt: {
        message: `Confirme que deseja ativar o estorno de transações`,
      },
      ar: {
        message: "أكد أنك تريد تفعيل إلغاء المعاملات",
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      setState((prevState) => ({ ...prevState, [e.target.name]: toggleReverse() }))
    }
  }

  const reverse = (data, meeting) =>
    dispatch(reverseTransaction(data, meeting))
  const setPage = (page) => dispatch(setCurrentPage(page))

  const reverseTxn = (data) => {
    const uid = currentMember.pubkey
    const lang_code = i18n.locale
    const amount = data.amount.toString()
    const lang = {
      fr: {
        message: `Confirmer la cotisation de ${amount} pour le membre`,
      },
      en: {
        message: `Confirm reversal of ${amount} for member`,
      },
      sw: {
        message: `Thibitisha kurejeshea mwanachama mchango wa shilingi ${amount}`,
      },
      es: {
        message: `Confirmar la reversión de ${amount} lempiras por miembro`,
      },
      lb: {
        message: `Confirm reversal of ${amount} for household`,
      },
      pt: {
        message: `Confirme o reverso de ${amount} para o membro`,
      },
      ar: {
        message: `${amount} أكد عكس معاملة المبلغ`,
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      reverse({ ...data, uid }, offlineMeeting)
      notify(<WarningMessage msg={"Processing Reversal"} />)
      setPage("group-memberList")
    }
  }

  const handleReversal = (
    id,
    full_name,
    transaction_type,
    amount,
    pubkey,
    destFundType,
    reversalTransactionType,
  ) => {
    const lang_code = i18n.locale
    const headers = {
      headers: {
        Authorization:
          "Bearer " + user.tokenBC || localStorage.getItem("tokenBC"),
      },
    }
    const amountStr = amount.toString()
    const lang = {
      fr: {
        message: `Confirmer la cotisation de ${amount} pour le membre`,
      },
      en: {
        message: `Confirm reversal of ${amount} for member`,
      },
      sw: {
        message: `Thibitisha kurejeshea mwanachama mchango wa shilingi ${amount}`,
      },
      es: {
        message: `Confirmar la reversión de ${amount} lempiras por miembro`,
      },
      lb: {
        message: `Confirm reversal of ${amount} for household`,
      },
      pt: {
        message: `Confirme o reverso de ${amount} para o membro`,
      },
      ar: {
        message: `${amount} أكد عكس معاملة المبلغ`,
      },
    }

    const txn = {
      id: id,
      pubkey: pubkey,
      full_name: full_name,
      transaction_type: transaction_type,
      amount: amount,
      reversal: false,
    }

    if (window.confirm(lang[lang_code].message)) {
      setState((prevState) => ({ ...prevState, loading: true }))

      blockchainAPI
        .post(
          `/vsla/${vsla?.id}/member/${member.id}/loan`,
          { amount: amountStr },
          headers,
        )
        .then(() => {
          return null
        })
        .then(() => {
          return memberToIssuer(
            id,
            txn,
            amountStr,
            vsla?.id,
            member.id,
            ongoingMeeting?.id,
            member.metadata?.member_uuid,
            reversalTransactionType,
            destFundType,
          )
        })
        .then(() => {
          updateTransanction(txn)
        })
        .catch((error) => {
          console.log("error", error)
          notify(<ErrorMessage />)
        })

      const timeout = 13000
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          reverse: false,
          redirect: true,
        }))
        notify(<SuccessMessage />)
      }, timeout)
    }
  }

  const { loading, redirect } = state

  const headerStyle = {
    color: "#E36F1E",
    fontFamily: "quicksand",
    fontWeight: "bolder",
    fontSize: "1.2rem",
    textAlign: "center",
    paddingBottom: "0.5em",
  }

  const checkboxStyle = {
    position: "relative",
    bottom: "0",
    width: "100%",
  }

  const listStyle = {
    color: "#343a40",
    fontFamily: "Fira Sans",
    fontSize: "20px",
    textAlign: "left",
  }

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: `/Groups/${vsla?.id}/members/${member.id}/Actions`,
          state: { vsla_id: vsla?.id },
        }}
      />
    )
  }

  if (loading) {
    return <StellarLoader />
  }

  if (ongoingMeeting && transactions.length < 1) {
    return (
      <div>
        {" "}
        <Alert color="warning">
          <span
            style={{
              fontFamily: "Fira Sans",
              fontSize: "16px",
            }}
          >
            <Trans id="no.reversible.transactions">
              No reversible transactions
            </Trans>
          </span>
        </Alert>
      </div>
    )
  }

  if (ongoingMeeting) {
    return (
      <Container>
        <FormTitle style={headerStyle} title={i18n._("Last Transaction")} />
        <ListGroup flush>
          {transactions.map((txn) => {
            return (
              <ListGroupItem style={listStyle} key={uuid.v4()}>
                <Row>
                  <Col>
                    <span>
                      {txn.amount} {getCurrency(group?.country).symbol}
                    </span>
                  </Col>
                  <Col>
                    <FormButton
                      handleClick={() => reverseTxn(txn)}
                      value={i18n._("Reverse")}
                      className="btn btn-lg form-control float"
                      disabled={
                        !state.reverse ||
                        (txn.type === "LOAN_INTEREST_REPAYMENT" &&
                          disableLoanInterestReversal)
                      }
                    />
                  </Col>
                </Row>
              </ListGroupItem>
            )
          })}
        </ListGroup>
        <Container>
          <Card style={checkboxStyle}>
            <Input
              name="reverse"
              type="checkbox"
              value={state.reverse}
              onChange={onChange}
              checked={state.reverse ? true : false}
            />
          </Card>
          <Alert color="warning">
            <span
              style={{
                fontFamily: "Fira Sans",
                fontSize: "16px",
              }}
            >
              <Trans id="activate.reversible.transactions">
                Activate reversible transactions
              </Trans>
            </span>
          </Alert>
        </Container>
      </Container>
    )
  }

  return <div></div>
}

LastLoanRepayment.propTypes = {
  offlineMeeting: PropTypes.object,
  member: PropTypes.object,
  transactions: PropTypes.array,
  disableLoanInterestReversal: PropTypes.bool,
}

export default LastLoanRepayment
